module.exports = __webpack_public_path__ + "static/media/ms-pink-panther.6e6b8b51.png";